import { styled, Typography } from "@mui/material";

export const AlertError = styled(Typography)`
    padding-top: 5px;
    color: #e15126;
    font-weight: bold;
    font-size: 11px;
    margin-bottom: 10px;
`;